<template>
  <div class="progress">
    <div
      v-if="!Globalfail"
      class="progress-bar bg-successful"
      role="progressbar"
      :style="{
        width: theGauge.Successful.max - theGauge.Successful.min + '%',
      }"
      :aria-valuenow="10"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div v-if="!Globalfail && ShowValue">{{ Successful }}</div>
    </div>
    <div
      v-if="!Globalfail"
      class="progress-bar bg-inProgress"
      role="progressbar"
      :style="{
        width: theGauge.InProgress.max - theGauge.InProgress.min + '%',
      }"
      aria-valuenow="10"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div v-if="!Globalfail && ShowValue">{{ InProgress }}</div>
    </div>
    <div
      class="progress-bar bg-failed"
      role="progressbar"
      :style="
        !Globalfail
          ? { width: theGauge.Failed.max - theGauge.Failed.min + '%' }
          : 'width:100%'
      "
      aria-valuenow="3"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div v-if="!Globalfail && ShowValue">{{ Failed }}</div>
    </div>
    <div
      v-if="!Globalfail"
      class="progress-bar bg-pending"
      role="progressbar"
      :style="{ width: theGauge.Pending.max - theGauge.Pending.min + '%' }"
      aria-valuenow="3"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div v-if="!Globalfail && ShowValue">{{ Pending }}</div>
    </div>
    <div
      v-if="!Globalfail"
      class="progress-bar bg-planned"
      role="progressbar"
      :style="{ width: theGauge.Planned.max - theGauge.Planned.min + '%' }"
      aria-valuenow="3"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div v-if="!Globalfail && ShowValue">{ {{ Planned }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "progressBarRange",

  props: {
    Globalfail: {
      type: Boolean,
      default: false,
    },
    ShowValue: {
      type: Boolean,
      default: true,
    },
    Pending: {
      type: Number,
      default: 0,
    },
    Failed: {
      type: Number,
      default: 0,
    },
    InProgress: {
      type: Number,
      default: 0,
    },
    Successful: {
      type: Number,
      default: 0,
    },
    Planned: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      theGauge: {
        pPending: 0,
        pFailed: 0,
        pInProgress: 0,
        pSuccessful: 0,
        pPlanned: 0,
        Pending: {
          min: 0,
          max: 0,
        },
        Failed: {
          min: 0,
          max: 0,
        },
        InProgress: {
          min: 0,
          max: 0,
        },
        Successful: {
          min: 0,
          max: 0,
        },
        Planned: {
          min: 0,
          max: 0,
        },
      },
    };
  },
  updated() {
    console.log("pending compenent  :" + this.Pending);
  },
  methods: {},
  mounted() {
    var somme =
      this.Pending +
      this.Successful +
      this.Failed +
      this.InProgress +
      this.Planned;

    this.pSuccessful = (this.Successful * 100) / somme;
    this.theGauge.Successful.min = 0;
    this.theGauge.Successful.max = this.pSuccessful;

    this.pInProgress = (this.InProgress * 100) / somme;
    this.theGauge.InProgress.min = this.theGauge.Successful.max;
    this.theGauge.InProgress.max =
      this.theGauge.InProgress.min + this.pInProgress;

    this.pFailed = (this.Failed * 100) / somme;
    this.theGauge.Failed.min = this.theGauge.InProgress.max;
    this.theGauge.Failed.max = this.theGauge.Failed.min + this.pFailed;

    this.pPending = (this.Pending * 100) / somme;
    this.theGauge.Pending.min = this.theGauge.Failed.max;
    this.theGauge.Pending.max = this.theGauge.Pending.min + this.pPending;

    this.pPlanned = (this.Planned * 100) / somme;
    this.theGauge.Planned.min = this.theGauge.Pending.max;
    this.theGauge.Planned.max = this.theGauge.Planned.min + this.pPlanned;

    console.log(this.pSuccessful);
    console.log(this.pInProgress);
    console.log(this.pFailed);
    console.log(this.pPending);
    console.log(this.pPlanned);
    console.log("Globalfail", this.Globalfail);
  },
};
</script>
<style scoped>
.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #3548af;
}

.bg-successful {
  --bs-bg-opacity: 1;
  background-color: #6b8e23 !important;
}
.bg-inProgress {
  --bs-bg-opacity: 1;
  background-color: #8fce00 !important;
}
.bg-failed {
  --bs-bg-opacity: 1;
  background-color: #f44336 !important;
}
.bg-pending {
  --bs-bg-opacity: 1;
  background-color: #d3d3d3 !important;
}
.bg-planned {
  --bs-bg-opacity: 1;
  background-color: #3aa9e2 !important;
}
</style>
